/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import NextLink from 'next/link';

const NextComposed = React.forwardRef((props, ref) => {
    const { as, href, notif, ...other } = props;

    return (
        <NextLink href={ href } as={ as }>
            <a ref={ ref } { ...other } data-notif={ notif } />
        </NextLink>
    );
});

NextComposed.propTypes = {
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    notif: PropTypes.string,
    prefetch: PropTypes.bool,
};

function NavLink(props) {
    const { href, activeClassName = 'active', className: classNameProps, innerRef, styled, ...other } = props;
    const router = useRouter();
    const pathname = typeof href === 'string' ? href : href.pathname;

    const className = clsx(classNameProps, {
        [activeClassName]: router.pathname.startsWith(pathname) && activeClassName,
    });

    return <NextComposed className={ className } ref={ innerRef } href={ href } { ...other } />;
}

NavLink.propTypes = {
    activeClassName: PropTypes.string,
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    className: PropTypes.string,
    notif: PropTypes.string,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    styled: PropTypes.bool,
    onClick: PropTypes.func,
    prefetch: PropTypes.bool,
};

export default React.forwardRef((props, ref) => <NavLink { ...props } innerRef={ ref } />);
